export default __webpack_public_path__ + "static/media/bkg--home-3.368de882.jpg";